import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaginationModule } from '../layout/pagination/pagination.module';
import { ErrorDetailComponent } from './modals/error-detail/error-detail.component';
import { ViewComponent } from './modals/view/view.component';
import { TransactionsComponent } from './transactions.component';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    TransactionsComponent,
    ViewComponent,
    ErrorDetailComponent,
  ],
  exports: [TransactionsComponent],
})
export class TransactionsModule {}
